export const escalaFuncionalList = {
  a: {
    label: "1. Falar",
    options: [
      {
        label: "Processo da fala normal",
        value: 4,
      },
      {
        label: "Distúrbio da fala detectável",
        value: 3,
      },
      {
        label: "Compreensível com repetição",
        value: 2,
      },
      {
        label: "Fala combinada com comunicação não-vocal",
        value: 1,
      },
      {
        label: "Perda da utilidade da fala",
        value: 0,
      },
    ],
  },
  b: {
    label: "2. Salivação",
    options: [
      {
        label: "Normal",
        value: 4,
      },
      {
        label:
          "Insignificante, mas notável o excesso de saliva na boca podendo ter babas noturnas",
        value: 3,
      },
      {
        label: "Excesso de saliva moderada, podendo ter mínimas babas",
        value: 2,
      },
      {
        label: "Excesso acentuado de saliva com alguma baba",
        value: 1,
      },
      {
        label:
          "Baba acentuada exigindo constatne uso de babador ou lenço para boca",
        value: 0,
      },
    ],
  },
  c: {
    label: "3. Deglutição",
    options: [
      {
        label: "Normal",
        value: 4,
      },
      {
        label: "Problemas precoces para comer, engasgos ocasionais",
        value: 3,
      },
      {
        label: "Alteração na consistência da dieta",
        value: 2,
      },
      {
        label: "Necessidade de suplemento alimentar pastoso",
        value: 1,
      },
      {
        label: "Nada pela boca, exclusivamente parenteral ou enteral",
        value: 0,
      },
    ],
  },
  d: {
    label: "4. Escrita",
    options: [
      {
        label: "Normal",
        value: 4,
      },
      {
        label: "Lentificada ou descuidada, todas as palavras são legíveis",
        value: 3,
      },
      {
        label: "Nem todas as palavras são legíveis",
        value: 2,
      },
      {
        label: "Capaz de segurar a caneta, mas incapaz de escrever",
        value: 1,
      },
      {
        label: "Não é capaz de segurar a caneta",
        value: 0,
      },
    ],
  },
  e: {
    label: "5. Manipulação de alimentos e utensílios",
    options: [
      {
        label: "Indivíduos sem gastrostomia",
        value: 4,
      },
      {
        label: "Indivíduos com gastrostomia",
        value: 3,
      },
    ],
  },
  e1: {
    label:
      "5a. Manipulação de alimentos e utensílios (indivíduos sem gastrostomia)",
    options: [
      {
        label: "Normal",
        value: 4,
      },
      {
        label: "Um pouco lento e desajeitado, mas não necessita de ajuda",
        value: 3,
      },
      {
        label:
          "Pode cortar o alimento embora lento e desajeitado; necessita de alguma ajuda",
        value: 2,
      },
      {
        label:
          "Alimentos cortados por outra pessoa, mas alimenta-se sozinho lentamente",
        value: 1,
      },
      {
        label: "Precisa ser alimentado",
        value: 0,
      },
    ],
  },
  e2: {
    label:
      "5b. Manipulação de alimentos e utensílios (indivíduos com gastrostomia)",
    options: [
      {
        label: "Normal",
        value: 4,
      },
      {
        label: "Desajeitado, mas capaz de desempenhar todas as manipulações",
        value: 3,
      },
      {
        label: "Alguma ajuda necessária com tampas e fechos",
        value: 2,
      },
      {
        label: "Oferece assistência minima ao cuidador",
        value: 1,
      },
      {
        label: "Incapaz de executar qualquer aspecto da tarefa",
        value: 0,
      },
    ],
  },
  f: {
    label: "6. Vestuário e Higiene",
    options: [
      {
        label: "Normal",
        value: 4,
      },
      {
        label:
          "Independente de autocuidado com diminuição do rendimento do esforço",
        value: 3,
      },
      {
        label: "Assistência intermitente ou substituição dos métodos",
        value: 2,
      },
      {
        label: "Necessita do cuidador para autocuidado",
        value: 1,
      },
      {
        label: "Dependência total",
        value: 0,
      },
    ],
  },
  g: {
    label: "7. Virar na cama e ajustar a roupa de cama",
    options: [
      {
        label: "Normal",
        value: 4,
      },
      {
        label: "Um pouco lento ou desajeitado, não necessita de ajuda",
        value: 3,
      },
      {
        label: "Pode virar sozinho ou ajustar o lençol com grande dificuldade",
        value: 2,
      },
      {
        label: "Tem iniciativa, não consegue virar ou ajustar o lençol sozinho",
        value: 1,
      },
      {
        label: "Incapaz",
        value: 0,
      },
    ],
  },
  h: {
    label: "8. Andar",
    options: [
      {
        label: "Normal",
        value: 4,
      },
      {
        label: "Deambulação precoce dificultada",
        value: 3,
      },
      {
        label: "Passeios com assistência",
        value: 2,
      },
      {
        label: "Movimento functional não-deambulatório somente",
        value: 1,
      },
      {
        label: "Não apresenta movimentação voluntária das pernas",
        value: 0,
      },
    ],
  },
  i: {
    label: "9. Subir escadas",
    options: [
      {
        label: "Normal",
        value: 4,
      },
      {
        label: "Lentidão",
        value: 3,
      },
      {
        label: "Ligeiro desequilíbrio ou fadiga",
        value: 2,
      },
      {
        label: "Necessita de assistência",
        value: 1,
      },
      {
        label: "Não realiza",
        value: 0,
      },
    ],
  },
  j: {
    label: "10. Dispnéia",
    options: [
      {
        label: "Nenhuma",
        value: 4,
      },
      {
        label: "Ocorre quando caminha",
        value: 3,
      },
      {
        label: "Ocorre quando come, toma banho e se veste",
        value: 2,
      },
      {
        label: "Ocorre no repouso, ou sentado ou deitado",
        value: 1,
      },
      {
        label: "Dificuldade significante, considerando suporte mecânico",
        value: 0,
      },
    ],
  },
  k: {
    label: "11. Ortopnéia",
    options: [
      {
        label: "Nenhuma",
        value: 4,
      },
      {
        label:
          "Alguma dificuldade de dormir, falta de ar, não se utiliza rotineiramente mais que 2 travesseiros",
        value: 3,
      },
      {
        label: "Necessita de travesseiros extras para dormir (mais que 2)",
        value: 2,
      },
      {
        label: "Pode dormir somente sentado",
        value: 1,
      },
      {
        label: "Não consegue dormir",
        value: 0,
      },
    ],
  },
  l: {
    label: "12. Insificiência respiratória",
    options: [
      {
        label: "Nenhuma",
        value: 4,
      },
      {
        label: "Uso intermitente do BIPAP",
        value: 3,
      },
      {
        label: "Uso contínuo do BIPAP à noite",
        value: 2,
      },
      {
        label: "Uso contínuo do BIPAP durante o dia e a noite",
        value: 1,
      },
      {
        label: "Ventilação mecânica invasiva por intubação",
        value: 0,
      },
    ],
  },
};
